import React from 'react';
import { Box, CircularProgress, Typography } from '@mui/material';

const LoadingSpinner = ({ message = 'Loading...', size = 40 }) => {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '200px',
        gap: 2,
      }}
      role="status"
      aria-live="polite"
    >
      <CircularProgress size={size} aria-hidden="true" />
      <Typography variant="body1" color="text.secondary">
        {message}
      </Typography>
      <span className="sr-only">{message}</span>
    </Box>
  );
};

export default LoadingSpinner;
